module.exports = __webpack_public_path__ + "static/media/authorized_parking.b23231ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parking_icons/authorized_parking.png
// module id = 1280
// module chunks = 0 1